// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hmjl","question":"styles_question__1gIB8","description":"styles_description__3A_w8"};